import * as React from 'react';
import { observer } from 'mobx-react';

import { DocumentTemplateBrandView } from './brand.view';
import { DocumentTemplateBrandDataService } from './brand-form.data';

interface Props extends ComponentViewProps<IDocumentTemplateItem> {
	dataService: DocumentTemplateBrandDataService;
	mode: ControlMode;
}

@observer
export class DocumentTemplateBrandController extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}

	handleCreateDocumentTemplateBrand = async(): Promise<DocumentTemplateBrandItem> => {
		const { dataService, model } = this.props;
		let brand = await dataService.add(model);
		return brand;
	};

	render() {
		const { dataService, mode, setBusy } = this.props;
		if (dataService == null || dataService.items == null) {
			return null;
		}

		return (
			<DocumentTemplateBrandView
				model={dataService}
				onCreateDocumentTemplateBrand={this.handleCreateDocumentTemplateBrand}
				mode={mode}
				setBusy={setBusy}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/document-templates/form/brands/brand.controller.tsx